<template>
  <div class="d--f jc--sb mt-20px">
    <AppButton variant="outlined" class="mr-10px" @click="emit('export', 'pdf')">
      <AppIcon color="primary" type="download" size="24" class="mr-5px" />
      Download PDF
    </AppButton>
    <AppButton variant="primary" @click="emit('export', 'email')">
      <AppIcon color="white" type="envelope" size="24" class="mr-5px" />
      Send Email
    </AppButton>
  </div>
</template>

<script setup>
import { AppButton, AppIcon } from "@/components/ui";

const emit = defineEmits(["export"]);
</script>
